import React from 'react';
import styled from 'styled-components';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { IGutterProps, useGutterCss } from '../../fundamentals/spaces/space';
import { FONT_SIZES } from '../../fundamentals/typography/typography';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { P } from '../Texts/Texts';
import { Icon } from '../Icon/Icon';
import { MATERIAL_ICONS, MATERIAL_ICONS_TYPES } from '../Icon/icons';
import { LinkButton } from '../LinkButton/LinkButton';
import { BaseDiv } from '../../common/BaseElements';

export type BreadCrumbPath = {
  name: string;
  onClick?: React.MouseEventHandler;
};

export interface IBreadcrumbProps extends IGutterProps {
  homeIcon?: boolean | React.ReactElement;
  path?: BreadCrumbPath[];
  onHomeClick?: React.MouseEventHandler;
}

export const BreadcrumbContainer = styled(BaseDiv)<IGutterProps>`
  display: flex;
  align-items: center;
  ${useGutterCss()}
`;

const ChevronIcon = () => <Icon name={MATERIAL_ICONS.ChevronRight} size={SIZES.XX_SMALL} gutterLeft={4} gutterRight={4} />;
const HOME_ICON = MATERIAL_ICONS.SpaceDashboard;

export const Breadcrumb: React.FC<IBreadcrumbProps> = ({ homeIcon = true, path, onHomeClick, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Breadcrumb');

  const others = path?.slice(0, -1);
  const last = path?.slice(-1).pop();

  return (
    <BreadcrumbContainer {...generateTestId()} {...rest}>
      {homeIcon && (homeIcon === true ? <Icon name={HOME_ICON} type={MATERIAL_ICONS_TYPES.OUTLINE} size={SIZES.XX_SMALL} onClick={onHomeClick} /> : homeIcon)}
      {others?.map((other, pos) => (
        <React.Fragment key={`path-${other.name}`}>
          {(pos || (homeIcon && !pos)) && <ChevronIcon />}
          <LinkButton size={SIZES.SMALL} onClick={other.onClick}>
            {other.name}
          </LinkButton>
        </React.Fragment>
      ))}
      {last && (
        <>
          <ChevronIcon />
          <P textSize={FONT_SIZES.TEXT_SMALL} gutter={false} onClick={last.onClick}>
            {last.name}
          </P>
        </>
      )}
    </BreadcrumbContainer>
  );
};
